module.exports = __webpack_public_path__ + "87d0054156f0df8767a24637e08a0ba8.pdf";